import { styled } from "@mui/material/styles";
import { Avatar, IconButton } from "@mui/material";

const DetailFormMain = styled("div")(({ theme, changeWidth = false }) => ({
  margin: "0 auto",
  width: changeWidth ? "50%" : "60%",
  marginTop: "40px",
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
}));
const UserAvatar = styled(Avatar)(({ theme }) => ({
  width: "70px",
  height: "70px",
  backgroundColor: "#0B0B0B",
  fontFamily: theme.typography.fontFamily,
}));

const CameraButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  bottom: 0,
  right: 0,
  width: "20px",
  height: "20px",

  color: "#000000",
  background: "#0B0B0B",
  border: "1.8px solid #FFFFFF",
  boxShadow: "0px 4.8px 96px rgba(167, 174, 193, 0.3)",
  borderRadius: "36px",
  "& svg": { fontSize: "10px", color: "#fff" },
  "&:hover": {
    backgroundColor: "#FFFFFF",
    "& svg": { color: "#0B0B0B", fontSize: "10px" },
  },
}));

const UserAvatarMian = styled("div")(({ theme }) => ({
  position: "relative",
  overflow: "hidden",
  width: "70px",
  height: "70px",
  [theme.breakpoints.down("md")]: {
    margin: "0 auto",
  },
}));
const DetailHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "30px",
}));
const UserInfo = styled("div")(({ theme }) => ({
  textAlign: "center",
  "& h6": {
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "30px",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
    // paddingLeft: "20px",
  },
  "& p": {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "17px",
    lineHeight: "20px",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
  },
}));

const FormPart = styled("div")(({ theme }) => ({
  marginTop: "40px",
  "& .FormItem": {
    display: "flex",
    alignItems: "center",
    gap: "30px",
  },
  "& .AuthInputMain": {
    width: "100%",
    marginBottom: "10px",
  },
  "& .PhoneInputsMain": {
    width: "100%",
  },
  "& .havePhone": {
    "& .AuthInputMain ": {
      paddingTop: "5px",
    },
  },
  "& .CustomerType": {
    width: "48%",
  },
  "& .ButtonMain": {
    display: "flex",
    alignItems: "center",
    gap: "30px",
    marginBottom: "50px",
  },
}));

export {
  DetailFormMain,
  UserAvatarMian,
  UserAvatar,
  CameraButton,
  DetailHeader,
  UserInfo,
  FormPart,
};
